// extracted by mini-css-extract-plugin
export default {"deliveryNoteValidation":"uploadDeliveryNoteModal_deliveryNoteValidation__ATJOl"};